import React, { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { setView, ViewName } from '../../../../slices/TicketDetailUISlice';
import { useReduxDispatch, useReduxSelector } from '../../../../redux/hooks';
import { SvgIcon } from '@progress/kendo-react-common';
import * as svg from '@progress/kendo-svg-icons';
import { UserApi } from '../../../../redux/api/UserApi';
import { isMobile } from 'react-device-detect';


const ActionTabs: React.FC = () => {
    //const [activeKey, setActiveKey] = useState<string>('note');
    const dispatch = useReduxDispatch();
    const selectedView = useReduxSelector(state => state.ticketDetailsUI.viewName);

    const handleSelect = (view: ViewName) => {
        dispatch(setView(view));
    };

    const { data: userProfile } = UserApi.useGetUserProfileQuery();
    if (userProfile?.Features.External_Interface || isMobile) return <div className='mt-2'></div>;

    return (
        <Tabs
            id="action-tabs"
            activeKey={selectedView}
            onSelect={(k) => handleSelect((k || 'notes') as ViewName)}
            className="action-tabs mt-2 justify-content-end flex"
        >
            <Tab eventKey="notes" title={<><SvgIcon icon={svg.stickyNoteIcon} className='m-1' />Notes</>}>
            </Tab>
            <Tab eventKey="timeline" title={<><img className='story-line' src='./images/toolbar/storyline.png' />Storyline</>}>
            </Tab>
            <Tab className='ai-tab' eventKey="summary" title={<><SvgIcon icon={svg.sparklesIcon} className='m-1' />AI Summary</>}>
            </Tab>
        </Tabs>
    );
};

export default ActionTabs;